import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from 'redux';
import { FeeManagementEdit, FeeManagementList, FeeManagementDetail } from './components';
import { FeeActions, NotificationActions } from '../../store';

const style = theme => ({
    root: {
        height: '100%'
    },
    visibleList: {
        height: '100%',
        visibility: 'visible'
    },
    hiddenList: {
        height: '100%',
        visibility: 'hidden'
    },
})

const IdentitySelector = (state) => state.Identity;
const FeeSelector = (state) => state.Fees;

const FeeManagement = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const feeActions = bindActionCreators(FeeActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { token } = useSelector(IdentitySelector);

    //const [mode, setMode] = useState('list');
    const [modeInfo, setModeInfo] = useState({ mode: 'list', merchant_name: '', merchant_type: '', period: '', credit_card_payment_agency_id: ''});
    const [listRefresh, setListRefresh] = useState(true);
    const { classes } = props;

    /**
     *
     * リスト画面表示
     *
     */
    const showList = () => {
        setListRefresh(false);
        //setMode('list');
        setModeInfo({ mode: 'list', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, period: modeInfo.period });
    }

    /**
     *
     * リスト画面表示(手数料設定一覧を再取得)
     *
     */
    const showListEdit = () => {
        setListRefresh(false);

        // 手数料設定一覧を取得
        feeActions.listFees(token)
            .then(data => {
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });

        //setMode('list');
        setModeInfo({ mode: 'list', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, period: modeInfo.period });
    }

    /**
     *
     * 登録画面表示
     *
     */
    const showCreate = (merchantName, merchantType, period, creditCardPaymentAgencyId) => {
        // 空の手数料設定情報を取得
        feeActions.loadEditModel(token, null, 0, null)
            .then(data => {
                //setMode('create');
                setModeInfo({ mode: 'create', merchant_name: merchantName, merchant_type: merchantType, period: period, credit_card_payment_agency_id: creditCardPaymentAgencyId });
            })
            .catch(e => {
                notificationActions.showError('手数料設定情報を取得できませんでした。');
            });
    }

    /**
     *
     * 詳細画面表示
     *
     * @param data 選択された行のデータ
     */
    const showDetail = (data, merchant_name, merchantType, period, creditCardPaymentAgencyId) => {
        // 対象の加盟店IDと連番から手数料設定情報を取得
        feeActions.loadEditModel(token, data.id, data.seq, data.credit_card_payment_agency_id)
            .then(data => {
                // 詳細画面に表示切替
                //setMode('detail');
                setModeInfo({ mode: 'detail', merchant_name: merchant_name, merchant_type: merchantType, period: period, credit_card_payment_agency_id: creditCardPaymentAgencyId });
            })
            .catch(e => {
                notificationActions.showError('手数料設定情報を取得できませんでした。');
            });
    }

    /**
     *
     * 詳細画面表示
     * （編集画面から詳細画面戻る際）
     *
     */
    const showDetailBack = () => {
        // 詳細画面を再表示
        //setMode('detail');
        setModeInfo({ mode: 'detail', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, period: modeInfo.period, credit_card_payment_agency_id: modeInfo.creditCardPaymentAgencyId });
    }

    /**
     *
     * 編集画面表示
     *
     */
    const showEdit = (data) => {
        //setMode('edit');
        setModeInfo({ mode: 'edit', merchant_name: modeInfo.merchant_name, merchant_type: modeInfo.merchant_type, period: modeInfo.period, credit_card_payment_agency_id: modeInfo.creditCardPaymentAgencyId });
    }

    var listClass = classes.hiddenList;

    //if (mode == 'list') {
    if (modeInfo.mode == 'list') {
        listClass = classes.visibleList;
    }

    var content = <div></div>;

    //登録
    //if (mode == 'create') {
    if (modeInfo.mode == 'create') {
        content = <FeeManagementEdit onCancel={showList} onUpdate={showListEdit} createFlag={true} />
    }

    //詳細
    //if (mode == 'detail') {
    if (modeInfo.mode == 'detail') {
        content = <FeeManagementDetail onEdit={showEdit} onCancel={showList} />
    }

    //編集
    //  if (mode == 'edit') {
    if (modeInfo.mode == 'edit') {
        content = <FeeManagementEdit onCancel={showDetailBack} onUpdate={showListEdit} createFlag={false} />
    }

    return (
        <div className={classes.root} maxWidth={false}>
            {content}
            <div className={listClass}>
                <FeeManagementList onCreate={showCreate} onDetail={showDetail} refresh={listRefresh}
                    merchantName={modeInfo.merchant_name} merchantType={modeInfo.merchant_type} period={modeInfo.period} creditCardPaymentAgencyId={modeInfo.credit_card_payment_agency_id} />
            </div>
        </div>
    )

}

export default withStyles(style, { withTheme: true })(FeeManagement);
